/* eslint react/no-direct-mutation-state: "off", 'jsx-a11y/alt-text': 'off','no-redeclare': 'off','no-dupe-keys': 'off', 'no-loop-func':'off', eqeqeq: 'off' */
import React,{Component} from "react";
import { connect } from "react-redux";
import CreateWorkOrder from "./_ModalsForms/CreateWorkOrder";
import { Modal } from 'reactstrap';
import { getUserDetailsAfterLogin, getUserPreferencesFromEquipmentSummary } from '../../../action/cultureAction';
import { WorkOrderRolePermission } from '../../../action/authenticateUser';
import { GetWorkorderTechnician, GetMailSetting, GetWorkOrderBuildingsEquipments, GetWorkOrderBuildings } from "../../../action/workorderAction";

class AlarmWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            SiteId: 0,
            SiteName: '',
            EquipmentId: 0,
            EquipmentName: '',
            Description: '',
            AlarmInfo: []
        };
        this.toggle = this.toggle.bind(this);
        //this.WrapperPopupCancel = this.WrapperPopupCancel.bind(this);
    }

    componentWillMount() {
        this.props.getUserPreferencesFromEquipmentSummary();
        this.props.getUserDetailsAfterLogin();
        this.props.WorkOrderRolePermission(24);
        this.props.GetWorkorderTechnician();
        this.props.GetMailSetting();
        this.props.GetWorkOrderBuildings();
        this.props.GetWorkOrderBuildingsEquipments(0);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });

    }

    WrapperPopupCancel = (IsSave) =>
    {        
        if(IsSave == 1)
        {
            window.fnClearCheckBoxForWorkorder();
        }
        this.setState({
            modal: false
        });      
    }

        Show = (siteId, objectId, description) =>{

        //if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0) {
                var Equipment_Name = '';
                var Equipment_Id = 0;
                var Building = (this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false).length > 0) ? this.props.getWorkOrderBuildings.filter(x => x.siteId == siteId && x.isDeleted == false) : [];
                this.props.getBuildingEquipments.forEach(building => {
                    if (building.equipment != undefined && building.equipment != null && building.equipment.length > 0) {
                        if(building.equipment.filter(x => x.objectId == objectId).length > 0)
                        {
                            Equipment_Name = building.equipment.filter(x => x.objectId == objectId)[0].objectName;
                            Equipment_Id = objectId;
                        }
                    }
                });

                var l_BuildingId = Building.length > 0 ? Building[0].id: 0;
                var l_BuildingName = Building.length > 0 ? Building[0].name: '';

                var AlarmLog = []
                var lineItem = {
                    "SiteId": l_BuildingId,
                    "SiteName": l_BuildingName,
                    "EquipmentId": Equipment_Id,
                    "EquipmentName": Equipment_Name,
                    "Description": (description !== undefined && description !== null) ? description : ''
                }
                AlarmLog.push(lineItem);

                this.setState({AlarmInfo: AlarmLog, modal: true});
        //}
        
        // this.setState({
        //     modal: true,
        //     SiteId: siteId,
        //     EquipmentId: objectId,
        //     Description: description
        // });       
    }

    showing = () =>{
        console.log("working on Alarm wrapper Component..");
            }

    render() {
        return (
            <div>
                <Modal zIndex={2147483646} isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} style={{'max-width':'750px !important'}}>
                    <CreateWorkOrder Premise={this.props.OnPremises} ForEquipment={true} ForAlarm={true} AlarmInfo={this.state.AlarmInfo} OnPopupCancel={this.WrapperPopupCancel} />
                </Modal>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
        UserCanEdit: state.authService.HasWorkOrderAccess,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserPreferencesFromEquipmentSummary: () => dispatch(getUserPreferencesFromEquipmentSummary()),
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        GetMailSetting: () => dispatch(GetMailSetting()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuildingsEquipments: (BuildingId) => dispatch(GetWorkOrderBuildingsEquipments(BuildingId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps,null,{forwardRef: true})(AlarmWrapper);